import { render, staticRenderFns } from "./AreasTree.vue?vue&type=template&id=9709f726&scoped=true"
import script from "./AreasTree.vue?vue&type=script&lang=js"
export * from "./AreasTree.vue?vue&type=script&lang=js"
import "./AreasTree.vue?vue&type=style&index=0&id=9709f726&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9709f726",
  null
  
)

export default component.exports